import { MoreHorizontal } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

/**
 * Kebab menu (⋯) — one primary trigger, list of secondary actions.
 * Items shape: [{ label, onClick, icon?, danger?, separatorBefore? }, ...]
 */
export default function KebabMenu({
  items = [],
  testid = "kebab",
  size = 32,
  align = "end",
  ariaLabel = "Više opcija",
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={testid}
          aria-label={ariaLabel}
          className="grid place-items-center rounded-md text-ink-muted hover:text-forest hover:bg-surface-secondary transition-colors"
          style={{ width: size, height: size }}
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal className="w-4 h-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={align}
        className="bg-white border-line min-w-[200px]"
        onClick={(e) => e.stopPropagation()}
      >
        {items.map((it, i) => (
          <span key={i}>
            {it.separatorBefore && <DropdownMenuSeparator />}
            <DropdownMenuItem
              data-testid={it.testid}
              onSelect={(e) => {
                e.preventDefault();
                it.onClick?.();
              }}
              disabled={it.disabled}
              className={
                (it.danger ? "text-terracotta focus:text-terracotta " : "") +
                "cursor-pointer"
              }
            >
              {it.icon ? <span className="mr-2 inline-flex items-center">{it.icon}</span> : null}
              {it.label}
            </DropdownMenuItem>
          </span>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
